<template>
  <div class="content-main">
    <div class="content" style="width: 100%">
      <div class="header flex justify-between items-center">
        <span>Warehouses (Depósitos)</span>
      </div>

      <div class="mb-4 px-4 flex gap-4 items-end">
        <div>
          <label class="block text-sm font-medium mb-1">Department</label>
          <select
            v-model="selectedDepartment"
            class="border rounded px-3 py-2"
            @change="page = 1"
          >
            <option value="">All Departments</option>
            <option
              v-for="dept in departments"
              :key="dept.departamentoId"
              :value="dept.departamentoId"
            >
              {{ dept.nombre || dept.codigo }}
            </option>
          </select>
        </div>
        <div class="flex-1">
          <label class="block text-sm font-medium mb-1">Search</label>
          <input
            v-model="search"
            type="text"
            class="w-full border rounded px-3 py-2"
            placeholder="Search by code, description..."
          />
        </div>
      </div>

      <div class="table">
        <table class="default-table" v-if="!loading">
          <thead>
            <tr class="table100-head">
              <th>ID</th>
              <th>Code</th>
              <th>Description</th>
              <th>Department</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="dep in paginatedDepositos" :key="dep.depositoId">
              <td>{{ dep.depositoId }}</td>
              <td>{{ dep.codDeposito }}</td>
              <td>{{ dep.descDeposito || "-" }}</td>
              <td>{{ getDepartmentName(dep.departamentoId) }}</td>
            </tr>
            <tr v-if="filteredDepositos.length === 0">
              <td colspan="4" class="text-center text-gray-500 py-4">
                No warehouses found
              </td>
            </tr>
          </tbody>
        </table>
        <div v-else class="p-8 text-center">Loading...</div>
      </div>

      <div class="footer">
        <div class="totals">
          showing {{ perPage * (page - 1) + 1 }} to
          {{ Math.min(perPage * page, filteredDepositos.length) }} from
          {{ filteredDepositos.length }} results
        </div>
        <div class="pages">
          <select v-model="perPage" @change="page = 1">
            <option :value="20">20</option>
            <option :value="50">50</option>
            <option :value="100">100</option>
          </select>
          Per Page
        </div>
        <div class="pages">
          <a
            class="page-link"
            :class="{ disabled: page <= 1 }"
            @click="previous"
          >
            Previous
          </a>
          <span>Page {{ page }}</span>
          <a
            class="page-link"
            :class="{ disabled: page >= totalPages }"
            @click="next"
          >
            Next
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDepartamentos, getDepositos } from "@/api/Infoauto.js";

export default {
  name: "WarehousesPage",
  data() {
    return {
      departments: [],
      depositos: [],
      loading: false,
      selectedDepartment: "",
      search: "",
      page: 1,
      perPage: 20
    };
  },
  computed: {
    filteredDepositos() {
      let list = this.depositos;
      if (this.selectedDepartment) {
        list = list.filter(
          d =>
            d.departamentoId === this.selectedDepartment ||
            d.departamento_id === this.selectedDepartment
        );
      }
      if (this.search) {
        const q = this.search.toLowerCase();
        list = list.filter(
          d =>
            (d.codDeposito || "").toLowerCase().includes(q) ||
            (d.descDeposito || "").toLowerCase().includes(q)
        );
      }
      return list;
    },
    totalPages() {
      return Math.ceil(this.filteredDepositos.length / this.perPage) || 1;
    },
    paginatedDepositos() {
      const start = (this.page - 1) * this.perPage;
      return this.filteredDepositos.slice(start, start + this.perPage);
    }
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;
      try {
        const [depts, deps] = await Promise.all([
          getDepartamentos(),
          getDepositos()
        ]);
        this.departments = depts || [];
        this.depositos = deps || [];
      } finally {
        this.loading = false;
      }
    },
    getDepartmentName(departamentoId) {
      const dept = this.departments.find(
        d => d.departamentoId === departamentoId
      );
      return dept ? dept.nombre || dept.codigo : departamentoId || "-";
    },
    previous() {
      if (this.page > 1) this.page--;
    },
    next() {
      if (this.page < this.totalPages) this.page++;
    }
  }
};
</script>
